import { inject, Injectable } from '@angular/core';
import { ApiService } from '@core/api';
import { Observable, Subject } from 'rxjs';
import {
  IConfirmTonDto,
  ICreateDepositDto,
  ICreateDepositResponse,
  ICreateStarsInvoiceResponse,
  ITonDepositStatusResponse,
  ICreateTonDepositDto,
  ICreateTonDepositResponse,
  GiftCatalogResponse,
  GiftDepositStartResponse,
} from '@domain/deposits';

@Injectable({
  providedIn: 'root',
})
export class DepositsApiService {
  readonly #baseApi = inject(ApiService);
  readonly #polling = new Subject<void>();

  public readonly polling$ = this.#polling.asObservable();

  public createDeposit(dto: ICreateDepositDto): Observable<ICreateDepositResponse> {
    return this.#baseApi.post('/deposits/send/create', dto);
  }

  public createRubDeposit(dto: { amount_stars: number; promo_code?: string }): Observable<{
    invoice_id: string;
    invoice_url: string;
    amount_stars: number;
    currency: string;
    crypto_amount: string;
    expires_at: string;
    promo_code: string;
    potential_bonus: number;
  }> {
    return this.#baseApi.post(`/deposits/rub/create`, dto);
  }

  public createTonDeposit(dto: ICreateTonDepositDto): Observable<ICreateTonDepositResponse> {
    return this.#baseApi.post('/ton-connect/deposit/create', dto);
  }

  public confirmTonDeposit(dto: IConfirmTonDto): Observable<any> {
    return this.#baseApi.post('/ton-connect/deposit/confirm', dto);
  }

  public getTonDepositStatus(tonDepositId: string): Observable<ITonDepositStatusResponse> {
    return this.#baseApi.get(`/ton-connect/deposit/${tonDepositId}/status`);
  }

  public createStarsDeposit(body: { amount_stars: number }): Observable<ICreateStarsInvoiceResponse> {
    return this.#baseApi.post(`/deposits/stars/create`, body);
  }

  public startGiftDeposit(): Observable<GiftDepositStartResponse> {
    return this.#baseApi.get<GiftDepositStartResponse>('/deposits/gifts/start');
  }

  public getGiftCatalog(forceRefresh = false): Observable<GiftCatalogResponse> {
    const params = forceRefresh ? { force_refresh: true } : {};
    return this.#baseApi.get<GiftCatalogResponse>('/deposits/gifts/catalog', params);
  }

  public startPolling(): void {
    this.#polling.next();
  }
}
